/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
import { useTranslation } from 'react-i18next';
import { ErinnerungsZeiten } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/erinnerungsZeiten';
import dayjs from 'dayjs';

export function useMapErinnerungszeitenToFristdatum(
  fristdatum: string | undefined,
): Array<{ value: string; label: string }> {
  const { t } = useTranslation();

  const options = Object.values(ErinnerungsZeiten).map<
    | {
        value: string;
        label: string;
      }
    | undefined
  >((val) => {
    switch (val) {
      case ErinnerungsZeiten.AM_GLEICHEN_TAG:
        if (
          fristdatum &&
          dayjs(fristdatum).isBefore(dayjs(new Date()), 'day')
        ) {
          return;
        }
        return {
          value: val,
          label: t(`domain.mitarbeiter.fristen.erinnerungsZeit.options.${val}`),
        };
      case ErinnerungsZeiten.EIN_TAG_ZUVOR:
        if (
          fristdatum &&
          dayjs(fristdatum)
            .startOf('day')
            .isBefore(dayjs(new Date()).startOf('day').add(1, 'day'), 'day')
        ) {
          return;
        }
        return {
          value: val,
          label: t(`domain.mitarbeiter.fristen.erinnerungsZeit.options.${val}`),
        };
      case ErinnerungsZeiten.EINE_WOCHE_ZUVOR:
        if (
          fristdatum &&
          dayjs(fristdatum)
            .startOf('day')
            .isBefore(dayjs(new Date()).startOf('day').add(7, 'day'), 'day')
        ) {
          return;
        }
        return {
          value: val,
          label: t(`domain.mitarbeiter.fristen.erinnerungsZeit.options.${val}`),
        };
      case ErinnerungsZeiten.ZWEI_WOCHEN_ZUVOR:
        if (
          fristdatum &&
          dayjs(fristdatum)
            .startOf('day')
            .isBefore(dayjs(new Date()).startOf('day').add(14, 'day'), 'day')
        ) {
          return;
        }
        return {
          value: val,
          label: t(`domain.mitarbeiter.fristen.erinnerungsZeit.options.${val}`),
        };
      case ErinnerungsZeiten.VIER_WOCHEN_ZUVOR:
        if (
          fristdatum &&
          dayjs(fristdatum)
            .startOf('day')
            .isBefore(
              dayjs(new Date())
                .startOf('day')
                .add(7 * 4, 'day'),
              'day',
            )
        ) {
          return;
        }
        return {
          value: val,
          label: t(`domain.mitarbeiter.fristen.erinnerungsZeit.options.${val}`),
        };
      case ErinnerungsZeiten.SECHS_WOCHEN_ZUVOR:
        if (
          fristdatum &&
          dayjs(fristdatum)
            .startOf('day')
            .isBefore(
              dayjs(new Date())
                .startOf('day')
                .add(7 * 6, 'day'),
              'day',
            )
        ) {
          return;
        }
        return {
          value: val,
          label: t(`domain.mitarbeiter.fristen.erinnerungsZeit.options.${val}`),
        };
      case ErinnerungsZeiten.DREI_MONATE_ZUVOR:
        if (
          fristdatum &&
          dayjs(fristdatum)
            .startOf('day')
            .isBefore(dayjs(new Date()).startOf('day').add(3, 'month'), 'day')
        ) {
          return;
        }
        return {
          value: val,
          label: t(`domain.mitarbeiter.fristen.erinnerungsZeit.options.${val}`),
        };
      default:
        break;
    }
  });

  return options.filter((option) => option !== undefined);
}
